<mat-dialog-content class="mat-typography">
  <h2>History - FM Ref #{{item}} </h2>
  <mat-card>
    @if (history && history.data) {
      <div class="history-table-scroll-container mat-elevation-z1">
        <mat-table [dataSource]="history.data.tableRows" multiTemplateDataRows>
          @for (column of history.data.tableDefinitions; track column) {
            <ng-container [matColumnDef]="column.columnDef">
              <mat-header-cell *matHeaderCellDef>{{ column.header }}</mat-header-cell>
              <mat-cell class="align-row" *matCellDef="let row; let i = dataIndex">
                {{ row[column.columnDef] }}
              </mat-cell>
            </ng-container>
          }
          <mat-header-row *matHeaderRowDef="tableDisplayedColumns; sticky: true"></mat-header-row>
          <mat-row *matRowDef="let row; columns: tableDisplayedColumns;" let dataIndex="dataIndex"
          class="example-element-row"></mat-row>
        </mat-table>
      </div>
    }
  </mat-card>
</mat-dialog-content>
<mat-dialog-actions align="center">
  <button mat-flat-button color="primary" mat-dialog-close cdkFocusInitial>Close</button>
</mat-dialog-actions>